import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Chip,
  Button,
} from '@mui/material';
import { AttachMoney } from '@mui/icons-material';
import { DESIGN_TOKENS } from '../../../design-system/tokens/colors';

export const SalesList: React.FC = () => {
  // Mock data - in a real app, this would come from an API
  const salesAnimals = [
    {
      id: '089',
      name: 'Vaca Jersey 089',
      breed: 'Jersey',
      age: '2 anos',
      weight: '380 kg',
      price: 'R$ 3.200',
      status: 'Disponível',
      image: '🐄',
    },
    {
      id: '156',
      name: 'Bezerro 156',
      breed: 'Nelore',
      age: '6 meses',
      weight: '180 kg',
      price: 'R$ 1.800',
      status: 'Disponível',
      image: '🐮',
    },
    {
      id: '203',
      name: 'Vaca Holandesa 203',
      breed: 'Holandesa',
      age: '4 anos',
      weight: '520 kg',
      price: 'R$ 4.200',
      status: 'Reservado',
      image: '🐄',
    },
    {
      id: '278',
      name: 'Touro Angus 278',
      breed: 'Angus',
      age: '3 anos',
      weight: '680 kg',
      price: 'R$ 8.500',
      status: 'Disponível',
      image: '🐂',
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 700, color: DESIGN_TOKENS.colors.primary[700] }}>
        Animais à Venda
      </Typography>
      <Typography variant="body1" sx={{ mb: 3, color: DESIGN_TOKENS.colors.text.secondary }}>
        {salesAnimals.filter(a => a.status === 'Disponível').length} animais disponíveis para venda
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
        {salesAnimals.map((animal) => (
          <Box key={animal.id} sx={{ flex: '1 1 300px', maxWidth: 400 }}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardContent sx={{ flex: 1 }}>
                <Box sx={{ textAlign: 'center', mb: 2 }}>
                  <Typography variant="h2" sx={{ mb: 1 }}>
                    {animal.image}
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: DESIGN_TOKENS.colors.primary[700] }}>
                    {animal.name}
                  </Typography>
                  <Typography variant="caption" sx={{ color: DESIGN_TOKENS.colors.text.secondary }}>
                    ID: #{animal.id}
                  </Typography>
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ color: DESIGN_TOKENS.colors.text.secondary, mb: 0.5 }}>
                    <strong>Raça:</strong> {animal.breed}
                  </Typography>
                  <Typography variant="body2" sx={{ color: DESIGN_TOKENS.colors.text.secondary, mb: 0.5 }}>
                    <strong>Idade:</strong> {animal.age}
                  </Typography>
                  <Typography variant="body2" sx={{ color: DESIGN_TOKENS.colors.text.secondary, mb: 0.5 }}>
                    <strong>Peso:</strong> {animal.weight}
                  </Typography>
                </Box>

                <Box sx={{ textAlign: 'center', mb: 2 }}>
                  <Typography variant="h5" sx={{ color: DESIGN_TOKENS.colors.organization.farm, fontWeight: 700, mb: 1 }}>
                    {animal.price}
                  </Typography>
                  <Chip
                    label={animal.status}
                    size="small"
                    color={animal.status === 'Disponível' ? 'success' : 'warning'}
                  />
                </Box>
              </CardContent>

              <Box sx={{ p: 2, pt: 0 }}>
                <Button
                  variant={animal.status === 'Disponível' ? 'contained' : 'outlined'}
                  fullWidth
                  disabled={animal.status !== 'Disponível'}
                  startIcon={<AttachMoney />}
                  sx={{
                    bgcolor: animal.status === 'Disponível' ? DESIGN_TOKENS.colors.organization.farm : undefined,
                    '&:hover': {
                      bgcolor: animal.status === 'Disponível' ? DESIGN_TOKENS.colors.primary[600] : undefined,
                    },
                  }}
                >
                  {animal.status === 'Disponível' ? 'Comprar' : 'Indisponível'}
                </Button>
              </Box>
            </Card>
          </Box>
        ))}
      </Box>
    </Box>
  );
};